import { selectCreativeLibrary } from '../../demo/creativeSelectors'
import { useChain } from '../../demo/selectors/chain'
import { useDemoStore } from '../../demo/store'
import { Card, GlossaryText, Icon } from '../../ui'
import common from './CreatePage.module.css'
import { createTakeoverCopy } from './copy'
import styles from './CreativeReady.module.css'
import { PLAN_DRAFT } from './planDraftData'

export function CreativeReady() {
  const creatives = useDemoStore((state) => state.creatives)
  const ads = useDemoStore((state) => state.ads)
  const campaigns = useDemoStore((state) => state.campaigns)
  const violations = useDemoStore((state) => state.violations)
  const risks = useDemoStore((state) => state.risks)
  const chain = useChain()
  const library = selectCreativeLibrary(creatives, ads, campaigns, violations, risks, { productId: PLAN_DRAFT.meta.productId })
  const selected = [
    ...library.filter((creative) => creative.source === 'ai').slice(0, 2),
    library.find((creative) => creative.source === 'kol'),
    library.find((creative) => creative.source === 'upload'),
  ].filter((creative) => creative !== undefined)
  const step = chain.steps.find((item) => item.id === '04')
  if (selected.length !== 4 || !step) throw new Error('第 04 步素材摘要缺少权威数据')
  const copy = createTakeoverCopy.creativeCard
  return (
    <Card className={common.takeoverCard} data-scope="creative-ready">
      <div className={common.cardHead}>
        <span className={common.aiBadge}><Icon name="sparkle" size={12} />{copy.badge}</span>
        <h3>{copy.title}</h3>
        <span className={common.cardStep}>{copy.step}</span>
      </div>
      <div className={common.cardBody}>
        <div className={styles.thumbnails} data-context="product-thumb">
          {selected.map((creative) => <img key={creative.id} src={creative.dataUrl ?? `/${creative.cover}`} alt={creative.name} />)}
        </div>
        <p className={`${common.tiny} ${common.muted} ${styles.action}`} data-role="creative-action">{step.trio.action}</p>
        <p className={`${common.tiny} ${styles.result}`} data-role="creative-result"><GlossaryText text={step.trio.result} paren /></p>
      </div>
    </Card>
  )
}
